import React from "react";
import { useTranslation } from "react-i18next";
import classNames from "classnames";
import { useFormContext } from "react-hook-form";
import QuickBetStore, {
	TFormFilter,
} from "@state/quick-play-store/QuickBetStore";
import { Button } from "@components/buttons";
import { useRootAppStore } from "@hooks";

export function QuickBetButtonType(
	props: QuickBetStore["QUICK_BET_TYPES_ARRAY"][0] & { isWidget?: boolean }
) {
	const { t } = useTranslation();
	const formContext = useFormContext<TFormFilter>();

	const rootStore = useRootAppStore();

	formContext.watch("quickBetType");

	const buttonClasses = classNames(
		"slip--quick__btn btn--block",
		{
			"btn--primary--inverted":
				formContext.getValues().quickBetType != props.quickBetType,
			"btn--accent is-disabled":
				formContext.getValues().quickBetType == props.quickBetType,
			"btn--wrap btn--wrap--med": props.isWidget,
		},
		"u-padd--xtny u-type--xsml"
	);

	return (
		<Button
			type="button"
			btnText={t(props.text)}
			disabled={
				formContext.getValues().quickBetType == props.quickBetType
			}
			className={buttonClasses}
			onClick={async () => {
				formContext.setValue("quickBetType", props.quickBetType);

				rootStore.quickPlayStore.quickBetStore.setGeneratedSlipError(
					null
				);

				await rootStore.quickPlayStore.quickBetStore.fetchData(
					formContext.getValues()
				);
			}}
		/>
	);
}
